/**
 * Semi-transparent watermark for Faraid PDF pages.
 */

import type { jsPDF } from 'jspdf';

export function drawPdfWatermark(
  doc: jsPDF,
  pageWidth: number,
  pageHeight: number
): void {
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(36);
  doc.setTextColor(220, 220, 220);
  doc.text('Kalkulator Faraid', pageWidth / 2, pageHeight / 2, {
    align: 'center',
    angle: 35,
  });
  doc.setTextColor(0, 0, 0);
}
